import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";

const _FM_ReservationErrorsListComponent = (props) => {

  const {t, i18n} = props;

  useEffect(() => {
    if (props.errors && props.errors[0]) {
      props.errors.map(error => {
        window.App.customToastShow('warn', error, '', 10000)
      })
    }
  }, [window.App.state.rerenderReservationErorrsList])

  return (
    <Panel className={"reservation-errors-list p-mt-3"} id={'errors'}>
      <h3 className={"p-mt-0"}>
        {t('errors')}
      </h3>
      <DataTable
        size={"small"}
        value={props.errors}
        emptyMessage={t('empty_message')}
        autoLayout={true}
        stripedRows
      >
        <Column header={t('error')} body={(rowData) => {
          return(
            <>
              {rowData}
            </>
          )
        }}></Column>
      </DataTable>
    </Panel>
  )
}
export default withTranslation('common')(_FM_ReservationErrorsListComponent);
